export default __webpack_public_path__ + "static/media/instagram-Contactus.fc4095fd.svg";